import { gql } from '@apollo/client';
import Member from 'models/member';

export interface Data {
  members: Array<Member>;
}

export const QUERY = gql`
  query Members($organizationId: ID!, $pageSize: Int, $pageNumber: Int, $searchTerm: String) {
    members(
      filter: { organizationId: $organizationId, pageSize: $pageSize, pageNumber: $pageNumber, searchTerm: $searchTerm }
    ) {
      data {
        id
        firstName
        lastName
        birthdate
        gender
        organizationId
        insertedAt
        joinedAt
        seasonParticipants(filter: { isArchived: false }) {
          season {
            id
            name
            isArchived
            program {
              id
              name
            }
          }
          referenceSeasonId
          seasonParticipantId
          seasonParticipantType
        }
      }
      metadata {
        pageNumber
        pageSize
        totalEntries
        totalPages
      }
    }
  }
`;
